module.exports = __webpack_public_path__ + "img/close-cross.34163b3e.svg";